import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-testimonials',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './testimonials.component.html',
  styleUrl: './testimonials.component.scss'
})
export class TestimonialsComponent {
  testimonials = [
    {
      id: 1,
      name: 'John Smith',
      title: 'CEO, Tech Solutions Inc.',
      content: 'Velora Infra delivered our commercial space on time and within budget. Their professionalism and attention to detail are unmatched.',
      rating: 5,
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop'
    },
    {
      id: 2,
      name: 'Sarah Johnson',
      title: 'Homeowner, Premium Residences',
      content: 'Our dream home became a reality thanks to Velora Infra. The quality and craftsmanship exceeded our expectations.',
      rating: 5,
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop'
    },
    {
      id: 3,
      name: 'Michael Chen',
      title: 'Property Developer',
      content: 'Working with Velora Infra has been a game-changer for our developments. Reliable, innovative, and results-driven.',
      rating: 5,
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop'
    },
  ];
}
